import axios from "axios";
import * as actionType from "../../constant/actionType";

export const DeleteWorkerNote = (note_id) => {
  return (dispatch) => {
    return axios({
      method: "delete",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/worker/DeleteWorkerNote`,
      params: { note_id },
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  };
};
